var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.incidents.length)?_c('div',{staticClass:"pr-2"},_vm._l((_vm.incidents),function(incident){return _c('incident-card',{key:incident.incidentId,attrs:{"incident":incident}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }